<template>
  <div>
    <div v-show="isDirectLuck || directLuck" class="luck-container" :class="!isMobile?'pt-16':''" v-loading="!showPrize" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <div v-if="!showPrize">
      <template v-if="isMobile">
        <van-loading size="24px" vertical>加载中...</van-loading>
      </template>
      <div class="no-data" v-else>恭喜您获得抽奖机会</div>
    </div>
    <div v-else>
      <!-- 九宫格抽奖 -->
      <div class="grid-content" v-if="type == 1">
        <div class="title" v-if="drawCount > 0">恭喜您获得 {{ drawCount }} 次抽奖机会!</div>
        <div class="title" v-else>抽奖机会已用完</div>
        <img class="bg" src="./assets/img/gridBg.png" />
        <div class="grid-box">
          <div :class="gridIndex == item.idx ? 'hover' : ''" class="grid" v-for="item in prize.slice(2, 5)" :key="item.idx">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
          <div v-for="item in prize.slice(1, 2)" :key="item.idx" :class="gridIndex == item.idx ? 'hover' : ''" class="grid">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
          <div class="grid-button" @click="draw(1)">立即抽奖</div>
          <div :class="gridIndex == item.idx ? 'hover' : ''" class="grid" v-for="item in prize.slice(5, 6)" :key="item.idx">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
          <div :class="gridIndex == item.idx ? 'hover' : ''" class="grid" v-for="item in prize.slice(0, 1)" :key="item.idx">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
          <div :class="gridIndex == item.idx ? 'hover' : ''" class="grid" v-for="item in prize.slice(7, 8)" :key="item.idx">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
          <div :class="gridIndex == item.idx ? 'hover' : ''" class="grid" v-for="item in prize.slice(6, 7)" :key="item.idx">
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </div>

      <!-- 大转盘抽奖 -->
      <div class="turntable-box" @click="draw(2)" v-else-if="type == 2">
        <div class="title" v-if="drawCount > 0">恭喜您获得 {{ drawCount }} 次抽奖机会!</div>
        <div class="title" v-else>抽奖机会已用完</div>
        <img class="bg" src="./assets/img/turntableBg.png" />
        <div class="draw-circle"></div>
        <img class="draw-btn" src="./assets/img/draw.png" />
        <img class="pointer" src="./assets/img/pointer.png" />
        <div
          class="turntable-inner"
          :style="{ transform: `rotate(${turntableRotate}deg)` }"
          :class="[initTurntable ? 'init' : '', runTurntable ? 'fast' : '', stopTurntable ? 'paused' : 'running']"
        >
          <div
            class="turntable"
            v-for="(item, index) in prize"
            :key="index"
            :style="{
              transform: `translateX(-50%) rotate(${(360 / prize.length) * index + 360 / prize.length / 2}deg)`,
              width: 244 * Math.tan(((360 / prize.length / 2) * Math.PI) / 180) + 'px'
            }"
          >
            <span>{{ item.name }}</span>
            <img v-if="item.name == '感谢参与'" src="./assets/img/smell.png" />
            <img v-else-if="item.image" :src="item.image" />
          </div>
        </div>
      </div>

      <!-- 刮刮乐抽奖 -->
      <div class="scrape-box" v-else-if="type == 3">
        <img class="bg" src="./assets/img/scrapBg.png" />
        <canvas
          id="scrapeCanvas"
          style="border-radius: 2px; overflow: hidden; z-index: 3"
          :disable-scroll="false"
          :width="canvasW * 0.5"
          :height="canvasH * 0.5"
        ></canvas>
        <div class="scrape-content" :style="{ width: canvasW * 0.5 + 'px', height: canvasH * 0.5 + 'px' }">
          <img v-if="prizeDetail.image" :src="prizeDetail.image" />
          <span>{{ prizeDetail.name }}</span>
        </div>
      </div>
      <p v-if="isIos" class="text-center text-gray-400 text-small mt-1">该活动由调研工厂提供，与设备生产商Apple Inc.无关</p>
      <!-- 中奖弹窗 -->
      <div class="receive-bg" v-if="showReceive">
        <div class="receive-box">
          <img class="bg" src="./assets/img/receiveBg.png" />
          <span class="ad">广告</span>
          <img @click="onlyClose" class="close" src="./assets/img/close.png" />
          <div v-if="prizeDetail.id" class="detail" :style="{ top: prizeDetail.image ? '81px' : '129px' }">
            <span class="title">恭喜获得</span>
            <span class="name" v-if="prizeDetail.description" v-html="prizeDetail.description"></span>
            <img
              :style="{
                width: prizeDetail.description && prizeDetail.description.length > 24 ? '92px' : '106px',
                height: prizeDetail.description && prizeDetail.description.length > 24 ? '92px' : '106px'
              }"
              v-if="prizeDetail.image"
              :src="prizeDetail.image"
            />
          </div>
          <div v-else class="detail" :style="{ top: '81px' }">
            <span class="title">感谢参与</span>
            <span class="name"
              >{{
                browserRedirect == 'mobileWx' ? '长按关注' : browserRedirect == 'mobile' ? '长按保存' : '点击保存'
              }}“调研工厂+”公众号，迎接下次中奖机会！</span
            >
            <img :style="{ width: '106px', height: '106px' }" src="./assets/img/gzh.jpeg" @click="saveImage()" />
          </div>
          <div v-if="prizeDetail.id" class="footer">
            <span class="notice">1小时内兑换有效</span>
            <div class="receive-button" @click="closeReceive">前往领取</div>
          </div>
        </div>
      </div>
    </div>
    </div>
    <div v-show="!(isDirectLuck || directLuck) && showMoreWonder" class="more-container">
      <p class="more-des">发现更多精彩，欢乐抽大奖</p>
      <div class="more-btn" @click="toShowPrize">点击抽奖</div>
      <img @click="toHideWonder" class="close-icon" src="./assets/img/close-icon.png">
    </div>
  </div>

</template>

<script>
import { busGetters,copyText } from 'dygc'
import { findOneUsingGET, addUsingPOST_1, postPrizePage, drawUsingPOST, receiveUsingPUT, queryUsingPOST } from './api'
let ctx
let timer

export default {
  name: 'Luck',
  props: {
    surveyId: {
      type: String,
      required: true
    },
    answerId: {
      type: String,
      required: true
    },
    bindEnabled:{
      type:Boolean,
      default:true,
    },
    readOnly: {
      type:Boolean,
      default:false,
    }
  },
  beforeMount() {
    // const timestamp = new Date().getTime()
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src = `https://pv.sohu.com/cityjson?ie=utf-8&timestamp='+${timestamp}+'`
    // document.body.appendChild(script)
    // setTimeout(() => {
    //   this.ip = returnCitySN && returnCitySN.cip ? returnCitySN.cip : '0.0.0.0'
    //   // console.log(returnCitySN.cip);
    // }, 100)
    this.getMethod()
    timer = setTimeout(() => {
      location.reload()
    }, 10 * 60 * 60 * 1000)
  },
  beforeDestroy() {
    if (timer) {
      clearTimeout(timer)
    }
  },
  computed: {
    // 判断页面是PC端还是移动端
    browserRedirect() {
      var sUserAgent = navigator.userAgent.toLowerCase()
      var bIsIpad = sUserAgent.match(/ipad/i) == 'ipad'
      var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
      var bIsMidp = sUserAgent.match(/midp/i) == 'midp'
      var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == 'rv:1.2.3.4'
      var bIsUc = sUserAgent.match(/ucweb/i) == 'ucweb'
      var bIsAndroid = sUserAgent.match(/android/i) == 'android'
      var bIsCE = sUserAgent.match(/windows ce/i) == 'windows ce'
      var bIsWM = sUserAgent.match(/windows mobile/i) == 'windows mobile'
      var bIsWX = sUserAgent.match(/MicroMessenger/i) == 'micromessenger'
      if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        if (bIsWX) {
          return 'mobileWx'
        } else return 'mobile'
      } else {
        return 'pc'
      }
    },
    isIos() {
      let sUserAgent = navigator.userAgent.toLowerCase()
      return sUserAgent.match(/iphone os/i) == 'iphone os'
    },
  },
  mounted() {
    this.directLuck= this.$bus.survey.otherSetting.directLuck
    if (this.browser().mobile || this.browser().android || this.browser.ios || document.body.clientWidth < 787) {
      // 判断是否是移动端
      this.isMobile = true
    } else {
      this.isMobile = false
    }
    window.addEventListener('resize', () => {
      if (this.browser().mobile || this.browser().android || this.browser.ios || document.body.clientWidth < 787) {
        // 判断是否是移动端
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    })
  },
  data() {
    return {
      showPrize: false,
      drawId: '',
      type: 0, // 1:九宫格, 2:大转盘, 3:刮刮乐
      prize: [],
      // ip: '0.0.0.0',
      // surveyId: '',
      // answerId: '',
      prizeDetail: {},
      prizeIndex: 0,
      showReceive: false,
      drawCount: 0, //抽奖次数
      inDraw: false, //是否正在抽奖
      // 九宫格data
      gridIndex: -1,
      gridCircle: 0,
      isGrid: false,
      // 大转盘data
      turntableRotate: 0,
      runTurntable: false,
      stopTurntable: false,
      initTurntable: false,
      // 刮刮乐
      clearNum: 0,
      canvasH: 312,
      canvasW: 622,
      isClear: false,
      isMobile: false,
      isDirectLuck:false,
      showMoreWonder:true,
      directLuck:false,
    }
  },
  methods: {
    toShowPrize(){
      this.isDirectLuck=true
    },
    toHideWonder(){
      this.showMoreWonder=false
    },
    browser() {
      // 获取浏览器UA标识
      var u = navigator.userAgent
      // Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/74.0.3729.131 Safari/537.36
      return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应该程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === ' qq' // 是否QQ
      }
    },
    //判断是否在微信小程序环境
    isWx() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return new Promise(resolve => {
          wx.miniProgram.getEnv(function(res) {
            if (res.miniprogram) {
              resolve("mini-wx");
            } else {
              resolve("wx");
            }
          });
        });
      } else {
        console.log("不在微信里");
        return new Promise(resolve => {
          resolve("no-wx");
        });
      }
    },
    getMethod() {
      return new Promise((resolve, reject) => {
        this.getCount().then(() => {
          findOneUsingGET()
            .then(res => {
              this.type = res.data.data.type
              return this.getPrize().then(() => {
                this.$nextTick(() => {
                  if (this.type == 3) {
                    this.initScrap()
                  }
                })
              })
            })
            .catch(err => {
              if (err && err.response && err.response.status === 429) {
                this.$message.error('请稍后再试！')
              }
            })
        })
      })
    },
    getCount() {
      return new Promise(resolve => {
        const queryParams = {
          wenjuanId: this.surveyId,
          accountUserId: this.$bus.params.accountUserId,
          accountUserOpenId: this.$bus.params.accountUserOpenId,
          accountUserFingerprint: this.$bus.accountUserFingerprint,
          surveyTitle: this.$bus.survey.title,
          // ipAddress: this.ip,
          bindEnabled:this.bindEnabled
        }
        // 非预览的情况 加参数
        if (!this.$bus.params.isTest) {
          queryParams.answerId = this.answerId
        }
        if (this.$bus.params.accountUsername) {
          queryParams.username = this.$bus.params.accountUsername
        }
        if (this.$bus.params.accountUserWxNickname) {
          queryParams.wxNikiName = this.$bus.params.accountUserWxNickname
        }
        queryUsingPOST(queryParams)
          .then(res => {
            this.drawCount = res.data.data.leftLotteryNum
            resolve()
          })
          .catch(err => {
            if (err && err.response && err.response.status === 429) {
              this.$message.error('请稍后再试！')
            }
          })
      })
    },
    getPrize() {
      return new Promise(resolve => {
        const queryParams = {
          wenjuanId: this.surveyId,
          accountUserId: this.$bus.params.accountUserId,
          accountUserOpenId: this.$bus.params.accountUserOpenId,
          accountUserFingerprint: this.$bus.accountUserFingerprint,
          bindEnabled:this.bindEnabled
        }
        // 非预览的情况 加参数
        if (!this.$bus.params.isTest) {
          queryParams.answerId = this.answerId
        }
        postPrizePage(queryParams)
          .then(res => {
            if (res.data.code !== 0) {
              this.$message.error(res.data.msg)
              return
            }
            // console.log(res);
            let arr = []
            arr.push({ ...res.data.data[0], idx: 0 })
            arr.push({ ...res.data.data[4], idx: 1 })
            arr.push({ ...res.data.data[1], idx: 2 })
            arr.push({ ...res.data.data[5], idx: 3 })
            arr.push({ ...res.data.data[2], idx: 4 })
            arr.push({ ...res.data.data[6], idx: 5 })
            arr.push({ ...res.data.data[3], idx: 6 })
            arr.push({ ...res.data.data[7], idx: 7 })
            if (this.type == 2) {
              arr = arr.reverse()
            }
            this.prize = arr
            if (this.drawCount <= 0 || this.readOnly) {
              resolve()
            } else {
              const queryParams = {
                wenjuanId: this.surveyId,
                accountUserId: this.$bus.params.accountUserId,
                accountUserOpenId: this.$bus.params.accountUserOpenId,
                accountUserFingerprint: this.$bus.accountUserFingerprint,
                surveyTitle: this.$bus.survey.title,
                // ipAddress: this.ip,
                bindEnabled:this.bindEnabled
              }
              // 非预览的情况 加参数
              if (!this.$bus.params.isTest) {
                queryParams.answerId = this.answerId
              }
              if (this.$bus.params.accountUsername) {
                queryParams.username = this.$bus.params.accountUsername
              }
              if (this.$bus.params.accountUserWxNickname) {
                queryParams.wxNikiName = this.$bus.params.accountUserWxNickname
              }
              addUsingPOST_1(queryParams).then(res => {
                this.drawId = res.data.data.id
                resolve()
              })
            }
            this.showPrize = true
          })
          .catch(err => {
            if (err && err.response && err.response.status === 429) {
              this.$message.error('请稍后再试！')
            }
          })
      })
    },
    // 抽奖
    draw(type) {
      if (this.inDraw) return
      this.inDraw = true
      if (this.drawCount <= 0) return
      // if (type == 1 || type == 2) this.drawCount--
      const queryParams = {
        lotteryLogId: this.drawId,
        wenjuanId: this.surveyId,
        accountUserId: this.$bus.params.accountUserId,
        accountUserOpenId: this.$bus.params.accountUserOpenId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        surveyTitle: this.$bus.survey.title,
        // ipAddress: this.ip,
        bindEnabled:this.bindEnabled
      }
      // 非预览的情况 加参数
      if (!this.$bus.params.isTest) {
        queryParams.answerId = this.answerId
      }
      if (this.$bus.params.accountUsername) {
        queryParams.username = this.$bus.params.accountUsername
      }
      if (this.$bus.params.accountUserWxNickname) {
        queryParams.wxNikiName = this.$bus.params.accountUserWxNickname
      }
      drawUsingPOST(queryParams).then(res => {
        this.prizeDetail = res.data.data
        this.prize.forEach((item, index) => {
          if (res.data.data.id) {
            if (item.id == res.data.data.id) {
              this.prizeIndex = index
            }
          } else {
            if (item.name == res.data.data.name) {
              this.prizeIndex = index
            }
          }
        })
        switch (type) {
          case 1:
            this.toGridGo()
            break
          case 2:
            this.TurntableGo()
            break
        }
      })
    },
    // 领取奖品
    receive() {
      const queryParams = {
        id: this.drawId,
        wenjuanId: this.surveyId,
        accountUserId: this.$bus.params.accountUserId,
        accountUserOpenId: this.$bus.params.accountUserOpenId,
        accountUserFingerprint: this.$bus.accountUserFingerprint,
        surveyTitle: this.$bus.survey.title,
        // ipAddress: this.ip,
        bindEnabled:this.bindEnabled
      }
      // 非预览的情况 加参数
      if (!this.$bus.params.isTest) {
        queryParams.answerId = this.answerId
      }
      if (this.$bus.params.accountUsername) {
        queryParams.username = this.$bus.params.accountUsername
      }
      if (this.$bus.params.accountUserWxNickname) {
        queryParams.wxNikiName = this.$bus.params.accountUserWxNickname
      }
      receiveUsingPUT(queryParams).then(res => {
        const link = this.prizeDetail.link
        this.initDraw().then(() => {
          const [type,...urls] = link.split(":")
          console.log(link)
          if (type === 'WX_API') {
            const url = urls.join(":")
            debugger
            fetch(url).then(res=>{
              return res.json().then((data)=>{
                if (this.$bus.currentBrowserInfo.isWeixin) {
                  window.location.href = data.jump
                  this.showReceive = false
                } else {
                  console.log(copyText)
                  // copyText('.receive-bg', data.jump).then(() => {
                  //   console.log("123")
                  //   this.$bus.option.message(0, '复制链接成功，请在微信中打开')
                  //   this.showReceive = false
                  // }).catch(err=>{
                  //   console.log("456")
                  //   console.log(err)
                  // })
                  let input = document.createElement('input')
                  input.setAttribute('readonly', 'readonly')
                  input.setAttribute('value', data.jump)
                  document.body.appendChild(input)
                  input.select()
                  if (document.execCommand('copy')) {
                    document.execCommand('copy')
                    this.$bus.busOption.message(0,"复制链接成功，请在微信中打开")
                  } else {
                    this.$bus.busOption.message(0,"奖品链接复制失败")
                  }
                  document.body.removeChild(input)
                  this.showReceive = false
                }
              })
            }).catch(()=>{
              this.$bus.busOption.message(2,"获取奖品链接失败")
              this.showReceive = false
            })
          }else {
            setTimeout(() => {
              if (this.isMobile) {
                this.isWx().then(type => {
                  if (type == "mini-wx") {
                    let input = document.createElement('input')
                    input.setAttribute('readonly', 'readonly')
                    input.setAttribute('value', link)
                    document.body.appendChild(input)
                    input.select()
                    if (document.execCommand('copy')) {
                      document.execCommand('copy')
                      this.$notify({
                        message: '奖品链接复制成功',
                        type: 'success'
                      })
                    } else {
                      this.$notify({
                        message: '奖品链接复制失败',
                        type: 'error'
                      })
                    }
                    document.body.removeChild(input)
                    this.showReceive = false
                  }else{
                    window.location.href = link
                    this.showReceive = false
                  }
                });
              } else {
                window.open(link, '_blank')
                this.showReceive = false
              }
            }, 1)
          }
        })
      })
    },
    // 九宫格转动
    toGridGo() {
      if (this.isGrid) return
      this.isGrid = true
      this.gridGo()
    },
    gridGo() {
      if (this.gridCircle >= 3 && this.gridIndex == this.prizeIndex) {
        // console.log(this.prizeIndex);
        this.toShowReceive()
        return
      }
      let gridCircle = this.gridCircle
      let index = this.gridIndex
      index++
      if (index >= 8) {
        index = 0
        gridCircle++
      }
      this.gridCircle = gridCircle
      this.gridIndex = index
      if ((gridCircle >= 2 && index >= 7) || gridCircle >= 3) {
        setTimeout(() => {
          this.gridGo()
        }, 300)
      } else if (gridCircle >= 2 && index >= 3) {
        setTimeout(() => {
          this.gridGo()
        }, 150)
      } else {
        setTimeout(() => {
          this.gridGo()
        }, 50)
      }
    },
    // 大转盘
    TurntableGo() {
      // this.runTurntable = true;
      // setTimeout(() => {
      //   this.stopTurntable = true;
      //   this.turntableRotate = 360 - (360 / this.prize.length) * this.prizeIndex;
      //   this.toShowReceive();
      // }, 3000);
      this.turntableRotate = 1440
      setTimeout(() => {
        this.stopTurntable = true
        // this.turntableRotate = 1800 + 360 - (360 / this.prize.length) * (this.prizeIndex + 1)
        this.turntableRotate = 1800 + 360 - (360 / this.prize.length) * this.prizeIndex - 360 / this.prize.length / 2
        setTimeout(() => {
          this.toShowReceive()
        }, 1800)
      }, 3000)
    },
    toShowReceive() {
      // if (!this.prizeDetail.id) return;
      this.showReceive = true
      this.drawCount--
      this.inDraw = false
    },
    // 刮刮乐
    initScrap() {
      const rpx = 0.5
      var c = document.getElementById('scrapeCanvas')
      c.onmousedown = () => {
        if (this.drawCount <= 0) return
        if (this.clearNum == 0) this.draw(3)
        this.clearNum++
        c.addEventListener('mousemove', this.eventMove)
      }
      c.onmouseup = () => {
        if (this.drawCount <= 0) return
        c.removeEventListener('mousemove', this.eventMove)
      }
      c.ontouchstart = () => {
        if (this.drawCount <= 0) return
        if (this.clearNum == 0) this.draw(3)
        this.clearNum++
        c.addEventListener('touchmove', this.touchMove)
      }
      c.ontouchend = () => {
        if (this.drawCount <= 0) return
        c.removeEventListener('touchmove', this.touchMove)
      }
      ctx = c.getContext('2d')
      // 画灰色涂层图片
      var img = new Image()
      img.src = require('./assets/img/background.png')
      const _this = this
      img.onload = function () {
        ctx.fillStyle = ctx.createPattern(img, 'repeat')
        ctx.fillRect(0, 0, _this.canvasW, _this.canvasH)
        ctx.textBaseline = 'top'
        ctx.fillStyle = '#000'
        ctx.font = '22px bold'
        if (_this.drawCount > 0) {
          ctx.textAlign = 'right'
          ctx.fillText(`恭喜您获得 `, (_this.canvasW * 0.5) / 2 - 2, 74 * rpx)
          ctx.textAlign = 'center'
          ctx.fillStyle = '#FF1405'
          ctx.fillText(`${_this.drawCount}`, (_this.canvasW * 0.5) / 2, 74 * rpx)
          ctx.textAlign = 'left'
          ctx.fillStyle = '#000'
          ctx.fillText(` 次刮奖机会!`, (_this.canvasW * 0.5) / 2 + 2, 74 * rpx)
        } else {
          ctx.textAlign = 'center'
          ctx.fillStyle = '#000'
          ctx.fillText(`抽奖机会已用完`, (_this.canvasW * 0.5) / 2, 74 * rpx)
        }
        ctx.save()
        ctx.beginPath()
        const x = 143 * rpx,
          y = 150 * rpx,
          w = 340 * rpx,
          h = 88 * rpx,
          r = 44 * rpx
        ctx.moveTo(x + r, y)
        ctx.arcTo(x + w, y, x + w, y + h, r)
        ctx.arcTo(x + w, y + h, x, y + h, r)
        ctx.arcTo(x, y + h, x, y, r)
        ctx.arcTo(x, y, x + w, y, r)
        ctx.closePath()
        ctx.strokeStyle = '#F63232' // 设置绘制圆形边框的颜色
        ctx.stroke()
        ctx.clip()
        // ctx.rect(x, y, w, h)
        // ctx.fillStyle = '#F63232'
        var grad = ctx.createLinearGradient(0, 0, w * 3, 0) //创建一个渐变色线性对象
        grad.addColorStop(0, '#FC7B53') //定义渐变色颜色
        grad.addColorStop(1, '#FD5560')
        ctx.fillStyle = grad //设置fillStyle为当前的渐变对象
        // ctx.fillRect(x, y, w, h);
        ctx.rect(x, y, w, h)
        ctx.fill()
        ctx.textAlign = 'center'
        ctx.fillStyle = '#fff'
        ctx.font = '19px normal'
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
          ctx.fillText('立即刮奖', (_this.canvasW * rpx) / 2, 170 * rpx)
        } else {
          ctx.fillText('立即刮奖', (_this.canvasW * rpx) / 2, 180 * rpx)
        }
        ctx.restore()
      }
    },
    touchStart(e) {
      this.eventMove(e)
    },
    eventMove(e) {
      let x = e.offsetX,
        y = e.offsetY
      if (this.isClear) return
      this.clearNum++
      if (this.clearNum >= 99) {
        // ctx.clearRect(0, 0, 500, 300);
        // this.toShowReceive();
        this.claerCanvas()
        this.isClear = true
      } else {
        ctx.beginPath()
        ctx.save()
        ctx.moveTo(x, y)
        ctx.arc(x, y, 10, 0, 2 * Math.PI)
        ctx.clip()
        ctx.clearRect(x - 10, y - 10, 20, 20)
        ctx.restore()
      }
    },
    touchMove(e) {
      e.stopPropagation()
      e.preventDefault()
      const rectObject = document.getElementById('scrapeCanvas').getBoundingClientRect()
      let x = e.touches[0].clientX - rectObject.left,
        y = e.touches[0].clientY - rectObject.top
      if (this.isClear) return
      this.clearNum++
      if (this.clearNum >= 99) {
        // ctx.clearRect(0, 0, 500, 300);
        // this.toShowReceive();
        this.claerCanvas()
        this.isClear = true
      } else {
        ctx.beginPath()
        ctx.save()
        ctx.moveTo(x, y)
        ctx.arc(x, y, 10, 0, 2 * Math.PI)
        ctx.clip()
        ctx.clearRect(x - 10, y - 10, 20, 20)
        ctx.restore()
      }
    },
    closeReceive() {
      this.receive()
    },
    onlyClose() {
      this.initDraw().then(() => {
        this.showReceive = false
      })
    },
    initDraw() {
      return new Promise(resolve => {
        if (this.drawCount == 0) {
          resolve()
          return
        }
        if (this.type == 3) {
          this.initScrap()
          this.clearNum = 0
          this.isClear = false
        } else if (this.type == 1) {
          this.gridIndex = -1
          this.gridCircle = 0
          this.isGrid = false
        } else if (this.type == 2) {
          this.initTurntable = true
          this.turntableRotate = 0
          this.runTurntable = false
          this.stopTurntable = false
          this.$nextTick(() => {
            setTimeout(() => {
              this.initTurntable = false
            }, 100)
          })
        }
        this.getPrize().then(() => {
          this.prizeDetail = {}
          resolve()
        })
      })
    },
    claerCanvas(width = 0) {
      const rpx = 0.5
      width += 2
      ctx.clearRect(this.canvasW * rpx * 0.5 - width / 2, 0, width, this.canvasH * rpx)
      if (width > this.canvasW * rpx) {
        this.toShowReceive()
        // this.drawCount--
        return
      } else {
        setTimeout(() => {
          this.claerCanvas(width)
        }, 10)
      }
    },
    // 保存公众号图片
    saveImage() {
      if (this.browserRedirect == 'pc') {
        const link = document.createElement('a')
        link.download = '调研工厂+.jpeg'
        link.style.display = 'none'
        link.href = require('./assets/img/gzh.jpeg')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.luck-container{
  padding-bottom: 16px;
}
.pt-16{
  padding-top: 16px;
}
// 九宫格
.grid-content {
  margin: 0 auto;
  position: relative;
  width: 300px;
  height: 353px;
  .bg {
    width: 100%;
    height: 100%;
  }
  .title {
    font-weight: 500;
    width: 100%;
    left: 0;
    text-align: center;
    font-size: 12px;
    color: #fff;
    top: 20px;
    position: absolute;
  }
}
.grid-box {
  position: absolute;
  bottom: 25px;
  left: 25px;
  // background-color: #9e0903;
  width: 251px;
  height: 247px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  justify-items: center;
  padding-top: 3px;

  .grid,
  .grid-button {
    width: 78px;
    height: 77px;
    background: #fff;
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    span {
      max-width: 62px;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      font-weight: 500;
      font-size: 12px;
      line-height: 13px;
      color: #333;
    }

    img {
      margin-bottom: 6px;
      width: 32px;
      height: 32px;
    }

    // &.hover::after {
    //   content: '';
    //   position: absolute;
    //   left: 0;
    //   top: 0;
    //   border-radius: 4px;
    //   width: 100%;
    //   height: 100%;
    //   background-color: #FFEC5F;
    //   opacity: 0.45;
    // }
  }
  .hover {
    background-color: #fde005;
  }
  .grid-button {
    background-color: #fc512e;
    box-sizing: border-box;
    padding: 8px;
    font-weight: 500;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 1.73px;
    text-align: center;
    line-height: 30px;
    cursor: pointer;
  }
}

// 大转盘
.turntable-box {
  width: 289px;
  height: 343px;
  margin: 0 auto;
  position: relative;

  .title {
    font-weight: 500;
    width: 100%;
    left: 0;
    text-align: center;
    font-size: 12px;
    color: #ffe85a;
    bottom: 11px;
    position: absolute;
  }

  .bg {
    width: 100%;
    height: 100%;
  }

  .draw-circle {
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    bottom: 158px;
    width: 86px;
    height: 86px;
    border-radius: 50px;
    background-color: #ffab23;
  }

  .draw-btn {
    position: absolute;
    z-index: 4;
    left: 50%;
    transform: translateX(-50%);
    bottom: 158px;
    width: 86px;
    height: 86px;
  }
  .pointer {
    position: absolute;
    z-index: 3;
    left: 50%;
    transform: translateX(-50%);
    bottom: 200px;
    width: 28px;
    height: 80px;
  }

  .turntable-inner {
    position: absolute;
    left: 22px;
    bottom: 77px;
    border-radius: 50%;
    overflow: hidden;
    width: 244px;
    height: 244px;
    transition: all 3s linear;
    background-color: #ffab23;
    // &.running {
    //   animation: toRotate 12s linear infinite;

    //   &.fast {
    //     animation: toRotate 1s linear infinite;
    //   }
    // }
    &.paused {
      transition: all 1.5s ease-out;
    }

    &.init {
      transition: none !important;
    }
  }

  @keyframes toRotate {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .turntable {
    position: absolute;
    // width: 100px;
    height: 50%;
    clip-path: polygon(50% 99%, 1% 0%, 100% 0%);
    -webkit-clip-path: polygon(50% 98%, 2px 0%, 99% 0%);
    transform-origin: 50% 100%;
    left: 50%;
    display: flex;
    justify-content: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff2e0;
    span {
      color: #333;
      font-size: 12px;
      font-weight: 500;
      margin-top: 15px;
    }

    img {
      margin-top: 6.5px;
      width: 32px;
      height: 32px;
    }
  }
}

// 刮刮乐
.scrape-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: 188px;

  .bg {
    z-index: 1;
    width: 343px;
    height: 188px;
    position: absolute;
  }
  .scrape-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 16px;
    height: 100%;
    width: 100%;
    background: #fff;
    z-index: 2;

    img {
      width: 100px;
      height: 100px;
      margin-bottom: 8px;
    }

    span {
      font-size: 14px;
    }
  }
}

// 中奖弹窗
.receive-bg {
  width: 100vw;
  height: 100vh;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  align-items: center;
  justify-content: center;
  animation: slidein 0.3s ease-in-out forwards;
  background: rgba(0, 0, 0, 0.5);
}
@keyframes slidein {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.ad {
  opacity: 0.65;
  font-size: 14px;
  color: #ffffff;
  position: absolute;
  top: 37px;
  left: 57px;
}
.receive-box {
  width: 343px;
  height: 408.5px;
  position: relative;

  .bg {
    width: 100%;
    height: 100%;
  }

  .close {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 29px;
    top: 0;
  }

  .detail {
    position: absolute;
    width: 100%;
    left: 0;
    top: 81px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .title,
    .name {
      font-weight: 500;
      font-size: 22px;
      color: #f08537;
      line-height: 22px;
      margin-bottom: 8px;
    }

    .name {
      max-width: 200px;
      font-size: 16px;
      margin-bottom: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    img {
      width: 92px;
      height: 92px;
    }
  }

  .footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 17px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .notice {
      opacity: 0.65;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      line-height: 18px;
      margin-bottom: 8px;
    }

    .receive-button {
      width: 170px;
      height: 44px;
      background-image: linear-gradient(180deg, #ffea86 0%, #ffb544 100%);
      box-shadow: inset 0 -3px 0 0 #e66c00;
      border-radius: 22px;
      font-weight: 500;
      font-size: 17px;
      color: #e34152;
      text-align: center;
      line-height: 44px;
      cursor: pointer;
    }
  }
}
.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  position: relative;
  height: 188px;
}
// 点击发现更多精彩
.more-container{
  height: 122px;
  border-radius: 12px;
  position: relative;
  background-image: linear-gradient(180deg, #FEEED6 0%, #FAE4BF 100%);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .close-icon{
    position: absolute;
    top: 6px;
    right: 6px;
  }
  .more-des{
    line-height: 22px;
    opacity: 0.85;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    margin-bottom: 12px;
  }
   .more-btn{
      width: 160px;
      height: 40px;
      background: #FF6040;
      border-radius: 22px;
      color: #fff;
      font-weight: 500;
      font-size: 16px;
      text-align: center;
      line-height: 40px;
    }
}
</style>
